
<template lang="pug">
.empty-coontainer
  img(:src="EMPTY_ICON")
  .text {{ text }}
  .btn(@click="clickBtn") 去看看
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '最近没有获得过奖励金，奖励金可兑换超值权益哦',
    },
  },
  data() {
    return {
      EMPTY_ICON: 'https://m.hellobike.com/resource/AppPlatformH5/bounty/Xi-64-VqhXfBUOQ2JPNvL.png',
    };
  },
  methods: {
    clickBtn() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
.empty-coontainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.56rem;
  padding-bottom: 1.05rem;

  img {
    width: 1.35rem;
    height: 0.97rem;
  }

  .text {
    font-size: 0.12rem;
    color: rgba(153, 153, 153, 1);
    white-space: nowrap;
    margin-top: 0.15rem;
    margin-bottom: 0.31rem;
  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.4rem;
    height: 0.41rem;
    background: rgba(11, 130, 241, 1);
    border-radius: 0.04rem;
    font-size: 0.16rem;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
